import React from "react";
import factory from "../../icons/factory.png";
import mechanic from "../../icons/mechanic.png";
import pic from "../../images/abouthome.png";

const HomeStrength = () => {
  return (<>
    <div className="container mt-5">
      <div className="row">
        <div className="col-lg-12">
          <div className="label-head  ">-- OUR STRENGTH --</div>
          <h1 className="">
            Our Craftsmanship <br />
            <span className="color-primary">
              turns your dream <br /> into Reality
            </span>
          </h1>
        </div>
        <div className="col-lg-4">
          <div className="row">
            <div className="col-lg-6">
              <img src={factory} alt="" className="w-60" />
              <h6 className="mt-5 mb-0">1 Lakh Sq.Ft</h6>
              <h6 className="color-primary">Factory Area</h6>
            </div>

            <div className="col-lg-6">
              <img src={mechanic} alt="" className="w-60" />
              <h6 className="mt-5 mb-0">200+ Employee</h6>
              <h6 className="color-primary">Man Power</h6>
            </div>
          </div>
        </div>
        <div className="col-lg-8">
            <div className="home-strength">
                <div>
                    <img src={pic} alt="" />
                    <p className="color-primary text-center fw-bold">Double Side Gluing Machine</p>
                </div>
                <div>
                    <img src={pic} alt="" />
                    <p className="color-primary text-center fw-bold">Multi-boring Machine</p>
                </div>
                <div>
                    <img src={pic} alt="" />
                    <p className="color-primary text-center fw-bold">Panel Saw</p>
                </div>
                <div>
                    <img src={pic} alt="" />
                    <p className="color-primary text-center fw-bold">Semi-Auto Edge-banding Machine</p>
                </div>
            </div>
        </div>
      </div>
    </div>
    <section class="a-section">
    <div class="a-section-marquee-box">
      <h2 class="marquee-text">Residential design *</h2>
      <h2 class="marquee-text">Commercial Design  *</h2>
      <h2 class="marquee-text">Hospitality Design  *</h2>
      <h2 class="marquee-text">Interior Design  *</h2>
      <h2 class="marquee-text">Luxury Furniture </h2>
    </div>
  </section>
    </>
  );
};

export default HomeStrength;
